import { render } from "./quyutype.vue?vue&type=template&id=00be5d08&scoped=true&ts=true"
import script from "./quyutype.vue?vue&type=script&lang=ts"
export * from "./quyutype.vue?vue&type=script&lang=ts"

import "./quyutype.vue?vue&type=style&index=0&id=00be5d08&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00be5d08"]])

export default __exports__